import React from 'react';
import Header from '../components/Header';
import { useParams } from "react-router-dom";
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

// URL for API
const URL = 'https://quiz5ll-server.herokuapp.com';
//const URL = 'http://localhost:8080';
//const URL = '';

let initialScores = [
    {
        name: 'doing',
		score: -1,
		pole: 'delegating'
    },
    {
        name: 'results',
		score: -1,
		pole: 'people'
    },
    {
        name: 'positivity',
		score: -1,
		pole: 'realism'
    },
    {
        name: 'privacy',
		score: -1,
		pole: 'transparency'
    },
    {
        name: 'acting',
		score: -1,
		pole: 'planning'
    },
    {
        name: 'directing',
		score: -1,
		pole: 'collaborating'
    },
    {
        name: 'self',
		score: -1,
		pole: 'team'
    },
    {
        name: 'delegating',
		score: -1,
		pole: 'doing'
    },
    {
        name: 'people',
		score: -1,
		pole: 'results'
    },
    {
        name: 'realism',
		score: -1,
		pole: 'positivity'
	}, 
	{
        name: 'transparency',
		score: -1,
		pole: 'privacy'
	},
	{
        name: 'planning',
		score: -1,
		pole: 'acting'
	},
	{
        name: 'collaborating',
		score: -1,
		pole: 'directing'
	},
	{
        name: 'team',
		score: -1,
		pole: 'self'
    }
];
function LikertManagementPolaritiesResult() {
    const [scores, setScores] = React.useState(null);
    const { id } = useParams();

	// call once
    if (scores === null) {
        // get quiz results
        fetch(`${URL}/management_polarities/result/${id}`, {
            method: 'get',
        })
            .then(res => res.json())
            .then(
                (r) => {
                    console.log('r', r.result);
                    const resultObj = {};
                    initialScores.forEach((row, index) => {
						resultObj[row.name] = {
							language: row.name.charAt(0).toUpperCase() + row.name.slice(1),
							value: r.result[row.name],
							pole: row.pole,
							pole_value: 0
						};
					});
					Object.keys(resultObj).forEach((row) => {
						resultObj[row].pole_value = resultObj[resultObj[row].pole].value;
					});
					console.log('SCORES', resultObj)
	                setScores(resultObj);
	           },
                (error) => {
                    console.log('ERROR', error);
                }
            )
    }
    if (scores === null) {
        return (
            <>
                <Header hideImage={true} />
                <div className="container" style={{ paddingTop: '50px', textAlign: 'center' }}>
                    <CircularProgress disableShrink />
                </div>
            </>
        )
    }

    return (
      <>
        <Header hideImage={true} />
        <div className="instructions">
          	<div className="container">
			  <Typography style={{ fontSize: '18px', fontWeight: '400'}}>
                    Your results below indicate areas of your leadership where you may be out of balance.
					Anywhere you score 50% or greater, go to that chapter in the book and learn ore about what this means for your management style and impact.
               </Typography>
          	</div>

        </div>

		<div className="container" style={{ height: '400px', marginTop: '20px'}}>
			<Grid container>
				<Grid item xs={12} sm={12} style={{textAlign: 'center', backgroundColor: '#eee', padding: '10px', borderRadius: '7px', marginBottom: '10px'}}>
					<Typography style={{ color: '#111', fontWeight: '400',  fontSize: '20px'}}>
						CHAPTER 4: What altitude do you fly at?
					</Typography>
				</Grid>
				<Grid item xs={6} sm={6} style={{textAlign: 'left',}}>
					<div style={{ display: 'block', marginTop: '20px',marginBottom: '10px', textAlign: 'left'}}>
						<div class="left-result" style={{ marginLeft: '0px', backgroundColor: '#BBDEFB', height: '30px', width: '100%', borderRight: '1px solid #fff', borderRadius:'8px'  }}>
							<div class="left-bar" style={{ fontFamily: 'Archivo', fontSize: '13px', borderRadius:'8px' , borderRight: '1px solid #fff', paddingLeft: scores['doing'].value !== 0 ? '15px' : '0px', paddingRight: scores['doing'].value !== 0 ? '15px' : '0px',fontWeight: '700', textAlign: 'left', lineHeight: '30px', height: '30px', width:`${scores['doing'].value}%`, backgroundColor: '#1E88E5', color: '#fff'}}>
								{scores['doing'].value !== 0 ? `${scores['doing'].value}%` : ''}
							</div>
						</div>
					</div>
					<Typography style={{fontSize: '16px'}}>
						<b>DOING</b>
					</Typography>
					<Typography style={{fontSize: '16px', width: '80%'}}>
						Focus on executing the tasks needed to achieve goals, attention to detail.
					</Typography>
					
				</Grid>

				<Grid item xs={6} sm={6} style={{textAlign: 'right'}}>
					<div style={{ display: 'block', marginTop: '20px', marginBottom: '10px', textAlign: 'right'}}>
						<div class="right-result" style={{ backgroundColor: '#BBDEFB', height: '30px', width: '100%', borderLeft: '1px solid #fff', borderRadius:'8px'  }}>
							<div class="right-bar" style={{fontFamily: 'Archivo', fontSize: '13px', borderRadius:'8px', borderleft: '1px solid #fff', paddingLeft: scores['doing'].pole_value !== 0 ? '15px' : '0px', paddingRight: scores['doing'].pole_value !== 0 ? '15px' : '0px', fontWeight: '700', textAlign: 'right', lineHeight: '30px', height: '30px', width:`${scores['doing'].pole_value}%`, backgroundColor: '#1E88E5', color: '#fff'}}>
								{scores['doing'].pole_value !== 0 ? `${scores['doing'].pole_value}%` : ''}
							</div>
						</div>
					</div>
					<Typography style={{fontSize: '16px'}}>
						<b>DELEGATING</b>
					</Typography>
					<Typography style={{fontSize: '16px', textAlign: 'right'}}>
						Focus on assigning tasks and responsibilities to others, big picture thinking.
					</Typography>
					
				</Grid>

				<Grid item xs={12} sm={12} style={{textAlign: 'center', backgroundColor: '#eee', padding: '10px', marginTop: '20px', borderRadius: '7px', marginBottom: '10px'}}>
					<Typography style={{ color: '#111', fontWeight: '400',  fontSize: '20px'}}>
					CHAPTER 5: How do you drive performance?
					</Typography>
				</Grid>
				<Grid item xs={6} sm={6} style={{textAlign: 'left'}}>
					<div style={{ display: 'block', marginTop: '20px', marginBottom: '10px', textAlign: 'center'}}>
						<div class="left-result" style={{ marginLeft: '0px', backgroundColor: '#BBDEFB', height: '30px', borderRadius:'8px', borderRight: '1px solid #fff', width: '100%' }}>
							<div class="left-bar" style={{ fontFamily: 'Archivo', fontSize: '13px', borderRadius:'8px', borderRight: '1px solid #fff', paddingLeft: scores['results'].value !== 0 ? '15px' : '0px', paddingRight: scores['results'].value !== 0 ? '15px' : '0px',fontWeight: '700', textAlign: 'left', lineHeight: '30px', height: '30px', width:`${scores['results'].value}%`, backgroundColor: '#1E88E5', color: '#fff'}}>
								{scores['results'].value !== 0 ? `${scores['results'].value}%` : ''}
							</div>
						</div>
					</div>

					<Typography style={{fontSize: '16px'}}>
					<b>RESULTS</b>
					</Typography>
					<Typography style={{fontSize: '16px', width: '80%'}}>
					Focus on outcomes independent of feelings.  Emphasis on accountability.
					</Typography>					
				</Grid>
				<Grid item xs={6} sm={6} style={{textAlign: 'right'}}>
					<div style={{ display: 'block', marginTop: '20px', marginBottom: '10px', textAlign: 'center'}}>
						<div class="right-result" style={{ backgroundColor: '#BBDEFB', height: '30px', borderRadius:'8px',borderLeft: '1px solid #fff', width: '100%' }}>
							<div class="right-bar" style={{fontFamily: 'Archivo', fontSize: '13px',borderRadius:'8px', borderLeft: '1px solid #fff', paddingLeft: scores['results'].pole_value !== 0 ? '15px' : '0px', paddingRight: scores['results'].pole_value !== 0 ? '15px' : '0px', fontWeight: '700', textAlign: 'right', lineHeight: '30px', height: '30px', width:`${scores['results'].pole_value}%`, backgroundColor: '#1E88E5', color: '#fff'}}>
								{scores['results'].pole_value !== 0 ? `${scores['results'].pole_value}%` : ''}
							</div>
						</div>
					</div>

					<Typography style={{fontSize: '16px'}}>
						<b>PEOPLE</b>
					</Typography>
					<Typography style={{fontSize: '16px', textAlign: 'right'}}>
					Focus on morale, positive culture, and concern for worker's feelings.
					</Typography>					
				</Grid>

				<Grid item xs={12} sm={12} style={{textAlign: 'center', backgroundColor: '#eee', padding: '10px', marginTop: '20px', borderRadius: '7px', marginBottom: '10px'}}>
					<Typography style={{ color: '#111', fontWeight: '400',  fontSize: '20px'}}>
					CHAPTER 6: How do you relate to the future?
					</Typography>
				</Grid>
				<Grid item xs={6} sm={6} style={{textAlign: 'left'}}>
					<div style={{ display: 'block', marginTop: '20px', marginBottom: '10px', textAlign: 'center'}}>
						<div class="left-result" style={{ marginLeft: '0px', backgroundColor: '#BBDEFB', height: '30px', width: '100%', borderRadius:'8px', borderRight: '1px solid #fff'}}>
							<div class="left-bar" style={{ fontFamily: 'Archivo', fontSize: '13px',  borderRadius:'8px', borderRight: '1px solid #fff', paddingLeft: scores['positivity'].value !== 0 ? '15px' : '0px', paddingRight: scores['positivity'].value !== 0 ? '15px' : '0px',fontWeight: '700', textAlign: 'left', lineHeight: '30px', height: '30px', width:`${scores['positivity'].value}%`, backgroundColor: '#1E88E5', color: '#fff'}}>
								{scores['positivity'].value !== 0 ? `${scores['positivity'].value}%` : ''}
							</div>
						</div>
					</div>

					<Typography style={{fontSize: '16px'}}>
					<b>POSITIVITY</b>
					</Typography>
					<Typography style={{fontSize: '16px', width: '80%'}}>
					Focus on a visionary and exciting future anticipating possibilities and dreaming big.
					</Typography>					
					
				</Grid>
				<Grid item xs={6} sm={6} style={{textAlign: 'right'}}>
					<div style={{ display: 'block', marginTop: '20px', marginBottom: '10px', textAlign: 'center'}}>
						<div class="right-result" style={{ backgroundColor: '#BBDEFB', height: '30px', width: '100%', borderRadius:'8px', borderLeft: '1px solid #fff', }}>
							<div class="right-bar" style={{fontFamily: 'Archivo', fontSize: '13px', borderRadius:'8px', borderLeft: '1px solid #fff', paddingLeft: scores['positivity'].pole_value !== 0 ? '15px' : '0px', paddingRight: scores['positivity'].pole_value !== 0 ? '15px' : '0px', fontWeight: '700', textAlign: 'right', lineHeight: '30px', height: '30px', width:`${scores['positivity'].pole_value}%`, backgroundColor: '#1E88E5', color: '#fff'}}>
								{scores['positivity'].pole_value !== 0 ? `${scores['positivity'].pole_value}%` : ''}
							</div>
						</div>
					</div>
					<Typography style={{fontSize: '16px'}}>
					<b>REALISM</b>
					</Typography>
					<Typography style={{fontSize: '16px', textAlign: 'right'}}>
					Focus on challenges, anticipating risks and protecting against them.
					</Typography>					

				</Grid>
				<Grid item xs={12} sm={12} style={{textAlign: 'center', backgroundColor: '#eee', padding: '10px', marginTop: '20px', borderRadius: '7px', marginBottom: '10px'}}>
					<Typography style={{ color: '#111', fontWeight: '400',  fontSize: '20px'}}>
					CHAPTER 7: How Do You Deal with Information?
					</Typography>
				</Grid>
				<Grid item xs={6} sm={6} style={{textAlign: 'left'}}>
					<div style={{ display: 'block', marginTop: '20px',marginBottom: '10px', textAlign: 'left'}}>
						<div class="left-result" style={{ marginLeft: '0px', backgroundColor: '#BBDEFB', height: '30px', width: '100%', borderRadius:'8px', borderRight: '1px solid #fff'  }}>
							<div class="left-bar" style={{ fontFamily: 'Archivo', fontSize: '13px', borderRight: '1px solid #fff', borderRadius:'8px', paddingLeft: scores['privacy'].value !== 0 ? '15px' : '0px', paddingRight: scores['privacy'].value !== 0 ? '15px' : '0px',fontWeight: '700', textAlign: 'left', lineHeight: '30px', height: '30px', width:`${scores['privacy'].value}%`, backgroundColor: '#1E88E5', color: '#fff'}}>
								{scores['privacy'].value !== 0 ? `${scores['privacy'].value}%` : ''}
							</div>
						</div>
					</div>
					<Typography style={{fontSize: '16px'}}>
						<b>PRIVACY</b>
					</Typography>
					<Typography style={{fontSize: '16px', width: '80%'}}>
					Focus on protection of information and discretion to protect people.
					</Typography>									
				</Grid>

				<Grid item xs={6} sm={6} style={{textAlign: 'right'}}>
					<div style={{ display: 'block', marginTop: '20px', marginBottom: '10px', textAlign: 'right'}}>
						<div class="right-result" style={{ marginLeft: '0px', backgroundColor: '#BBDEFB', height: '30px', width: '100%', borderRadius:'8px', borderLeft: '1px solid #fff'}}>
							<div class="right-bar" style={{fontFamily: 'Archivo', fontSize: '13px', borderLeft: '1px solid #fff', borderRadius:'8px', paddingLeft: scores['privacy'].pole_value !== 0 ? '15px' : '0px', paddingRight: scores['privacy'].pole_value !== 0 ? '15px' : '0px', fontWeight: '700', textAlign: 'right', lineHeight: '30px', height: '30px', width:`${scores['privacy'].pole_value}%`, backgroundColor: '#1E88E5', color: '#fff'}}>
								{scores['privacy'].pole_value !== 0 ? `${scores['privacy'].pole_value}%` : ''}
							</div>
						</div>

					</div>
					<Typography style={{fontSize: '16px'}}>
						<b>TRANSPARENCY</b>
					</Typography>
					<Typography style={{fontSize: '16px', textAlign: 'right'}}>
					Focus on access to information. Sharing more to increase trust.
					</Typography>										
				</Grid>
				<Grid item xs={12} sm={12} style={{textAlign: 'center', backgroundColor: '#eee', padding: '10px', marginTop: '20px', borderRadius: '7px', marginBottom: '10px'}}>
					<Typography style={{ color: '#111', fontWeight: '400',  fontSize: '20px'}}>
					CHAPTER 8: How Fast Do You Move?
					</Typography>
				</Grid>
				<Grid item xs={6} sm={6} style={{textAlign: 'left'}}>
					<div style={{ display: 'block', marginTop: '20px',marginBottom: '10px', textAlign: 'left'}}>
						<div class="left-result" style={{ marginLeft: '0px',backgroundColor: '#BBDEFB', height: '30px', width: '100%', borderRadius:'8px', borderRight: '1px solid #fff'  }}>
							<div class="left-bar" style={{ fontFamily: 'Archivo', fontSize: '13px', borderRight: '1px solid #fff',borderRadius:'8px',  paddingLeft: scores['acting'].value !== 0 ? '15px' : '0px', paddingRight: scores['acting'].value !== 0 ? '15px' : '0px',fontWeight: '700', textAlign: 'left', lineHeight: '30px', height: '30px', width:`${scores['acting'].value}%`, backgroundColor: '#1E88E5', color: '#fff'}}>
								{scores['acting'].value !== 0 ? `${scores['acting'].value}%` : ''}
							</div>
						</div>
					</div>

					<Typography style={{fontSize: '16px'}}>
						<b>ACTING</b>
					</Typography>
					<Typography style={{fontSize: '16px', width: '80%'}}>
					Focus on forward movement, quick decision making, and gut instinct.
					</Typography>														
				</Grid>

				<Grid item xs={6} sm={6} style={{textAlign: 'right'}}>
					<div style={{ display: 'block', marginTop: '20px', marginBottom: '10px', textAlign: 'right'}}>
						<div class="right-result" style={{ backgroundColor: '#BBDEFB', height: '30px', width: '100%', borderRadius:'8px', borderLeft: '1px solid #fff' }}>
							<div class="right-bar" style={{fontFamily: 'Archivo', fontSize: '13px', borderLeft: '1px solid #fff', borderRadius:'8px', paddingLeft: scores['acting'].pole_value !== 0 ? '15px' : '0px', paddingRight: scores['acting'].pole_value !== 0 ? '15px' : '0px', fontWeight: '700', textAlign: 'right', lineHeight: '30px', height: '30px', width:`${scores['acting'].pole_value}%`, backgroundColor: '#1E88E5', color: '#fff'}}>
								{scores['acting'].pole_value !== 0 ? `${scores['acting'].pole_value}%` : ''}
							</div>
						</div>
					</div>
					<Typography style={{fontSize: '16px'}}>
						<b>PLANNING</b>
					</Typography>
					<Typography style={{fontSize: '16px'}}>
					Focus on thoughtful planning, data gathering, and reflecting before acting.
					</Typography>									
					
				</Grid>
				<Grid item xs={12} sm={12} style={{textAlign: 'center', backgroundColor: '#eee', padding: '10px', marginTop: '20px', borderRadius: '7px', marginBottom: '10px'}}>
					<Typography style={{ color: '#111', fontWeight: '400',  fontSize: '20px'}}>
					CHAPTER 9: How Do You Guide Your Team?
					</Typography>
				</Grid>
				<Grid item xs={6} sm={6} style={{textAlign: 'left'}}>
					<div style={{ display: 'block', marginTop: '20px',marginBottom: '10px', textAlign: 'left'}}>
						<div class="left-result" style={{ marginLeft: '0px',backgroundColor: '#BBDEFB', height: '30px', width: '100%', borderRadius:'8px', borderRight: '1px solid #fff'  }}>
							<div class="left-bar" style={{ fontFamily: 'Archivo', fontSize: '13px', borderRight: '1px solid #fff', borderRadius:'8px',  paddingLeft: scores['directing'].value !== 0 ? '15px' : '0px', paddingRight: scores['directing'].value !== 0 ? '15px' : '0px',fontWeight: '700', textAlign: 'left', lineHeight: '30px', height: '30px', width:`${scores['directing'].value}%`, backgroundColor: '#1E88E5', color: '#fff'}}>
								{scores['directing'].value !== 0 ? `${scores['directing'].value}%` : ''}
							</div>
						</div>
					</div>

					<Typography style={{fontSize: '16px'}}>
						<b>DIRECTING</b>
					</Typography>
					<Typography style={{fontSize: '16px', width: '80%'}}>
					Focus on providing clear answers, sharing your perspective, and giving direction.
					</Typography>														
					
				</Grid>

				<Grid item xs={6} sm={6} style={{textAlign: 'right'}}>
					<div style={{ display: 'block', marginTop: '20px', marginBottom: '10px', textAlign: 'right'}}>
						<div class="right-result" style={{ backgroundColor: '#BBDEFB', height: '30px', width: '100%', borderRadius:'8px', borderLeft: '1px solid #fff'}}>
							<div class="right-bar" style={{fontFamily: 'Archivo', fontSize: '13px', borderRadius:'8px', borderLeft: '1px solid #fff', paddingLeft: scores['directing'].pole_value !== 0 ? '15px' : '0px', paddingRight: scores['directing'].pole_value !== 0 ? '15px' : '0px', fontWeight: '700', textAlign: 'right', lineHeight: '30px', height: '30px', width:`${scores['directing'].pole_value}%`, backgroundColor: '#1E88E5', color: '#fff'}}>
								{scores['directing'].pole_value !== 0 ? `${scores['directing'].pole_value}%` : ''}
							</div>
						</div>
					</div>
					<Typography style={{fontSize: '16px'}}>
						<b>COLLABORATING</b>
					</Typography>
					<Typography style={{fontSize: '16px'}}>
					Focus on asking questions, gathering opinions, and harmonizing approaches.
					</Typography>									
					
				</Grid>
				<Grid item xs={12} sm={12} style={{textAlign: 'center', backgroundColor: '#eee', padding: '10px', marginTop: '20px', borderRadius: '7px', marginBottom: '10px'}}>
					<Typography style={{ color: '#111', fontWeight: '400',  fontSize: '20px'}}>
					CHAPTER 10: How Do You Acknowledge Contribution?
					</Typography>
				</Grid>
				<Grid item xs={6} sm={6} style={{textAlign: 'left'}}>
					<div style={{ display: 'block', marginTop: '20px',marginBottom: '10px', textAlign: 'left'}}>
						<div class="left-result" style={{ marginLeft: '0px',backgroundColor: '#BBDEFB', height: '30px', width: '100%', borderRadius:'8px', borderRight: '1px solid #fff'  }}>
							<div class="left-bar" style={{ fontFamily: 'Archivo', fontSize: '13px', borderRight: '1px solid #fff',borderRadius:'8px',  paddingLeft: scores['self'].value !== 0 ? '15px' : '0px', paddingRight: scores['self'].value !== 0 ? '15px' : '0px',fontWeight: '700', textAlign: 'left', lineHeight: '30px', height: '30px', width:`${scores['self'].value}%`, backgroundColor: '#1E88E5', color: '#fff'}}>
								{scores['self'].value !== 0 ? `${scores['self'].value}%` : ''}
							</div>
						</div>
					</div>

					<Typography style={{fontSize: '16px'}}>
						<b>ACKNOWLEDGE SELF</b>
					</Typography>
					<Typography style={{fontSize: '16px', width: '80%'}}>
					Focus on revealing your unique contribution and value to build credibility
					</Typography>														
					
				</Grid>

				<Grid item xs={6} sm={6} style={{textAlign: 'right', marginBottom: '40px'}}>
					<div style={{ display: 'block', marginTop: '20px', marginBottom: '10px', textAlign: 'right'}}>
						<div class="right-result" style={{ backgroundColor: '#BBDEFB', height: '30px', width: '100%', borderRadius:'8px', borderLeft: '1px solid #fff'}}>
							<div class="right-bar" style={{fontFamily: 'Archivo', fontSize: '13px', borderLeft: '1px solid #fff', borderRadius:'8px', paddingLeft: scores['self'].pole_value !== 0 ? '15px' : '0px', paddingRight: scores['self'].pole_value !== 0 ? '15px' : '0px', fontWeight: '700', textAlign: 'right', lineHeight: '30px', height: '30px', width:`${scores['self'].pole_value}%`, backgroundColor: '#1E88E5', color: '#fff'}}>
								{scores['self'].pole_value !== 0 ? `${scores['self'].pole_value}%` : ''}
							</div>
						</div>
					</div>
					<Typography style={{fontSize: '16px'}}>
						<b>ACKNOWLEDGE TEAM</b>
					</Typography>
					<Typography style={{fontSize: '16px'}}>
					Focus on recognizing team member contributions and their value to drive motivation.
					</Typography>									
					
				</Grid>
				
			</Grid>
		</div>
      </>
    );
}

export default LikertManagementPolaritiesResult;
